import { Grid, Box, Typography, Avatar, CardMedia } from '@mui/material'
import CardScoreComponent from '../CardScoreComponent/CardScoreComponent'
import { makeLogRequest } from '../../../utils/AuditLogs'
import { convertNumberIntoLacsCr } from '../../ReusableComponents.js/reuseMethods'
import { useNavigate } from 'react-router-dom'
import { getIds } from '../../ReusableComponents.js/getIds'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import third from '../../../asserts/images/3rd.png'
import first from '../../../asserts/images/1st.png'
import second from '../../../asserts/images/2nd.png'
import './CardComponent.css'
import { useEffect, useState } from 'react'

const EngagementCard = ({ mp, index, selectedCard }) => {
  const navigate = useNavigate()
  const loggedInId = getIds()
  const [columns, setColumns] = useState([])
  const ranking = {
    1: first,
    2: second,
    3: third,
  }

  const handleCardlogs = (mp_id, index) => {
    const parameters = {
      rank: index + 1,
      mp_id: mp_id,
      section: selectedCard,
      useridtype: getIds(),
    }
    makeLogRequest('mp_leaderboard', 'mp_card', parameters)
  }

  const handleCardClick = () => {
    if (mp?.hasOwnProperty('isMP') && mp?.isMP == 0) {
      return
    }
    if (!window.getSelection().toString()) {
      if (mp.id === loggedInId) {
        navigate('/MySevaUpdates', {
          state: {
            MpName: 'My Seva Rank',
            mpId: loggedInId,
          },
        })
      } else {
        navigate('/MpSevaUpdates', {
          state: {
            MpName: mp.user_name,
            mpId: mp.id,
            mpClick: true,
            mpData: mp && mp,
          },
        })
      }
    }
    handleCardlogs(mp.id, index)
  }
  useEffect(() => {
    if (selectedCard?.labels) {
      let items = selectedCard?.labels?.split(',')
      if (items?.length > 1) {
        setColumns(items)
      } else {
        setColumns([items])
      }
    }
  }, [selectedCard])
  return (
    <Grid key={index} item xs={12} md={12} lg={4} xl={4}>
      <Box className="cursor-pointer" onClick={handleCardClick}>
        <Box>
          <Box className="Cards position-relative card-shadow">
            {Object.keys(ranking).includes(index.toString()) ? (
              <Box sx={{ maxWidth: '35px' }}>
                <CardMedia
                  component="img"
                  alt="rank"
                  src={ranking[index]}
                  sx={{ opacity: selectedCard?.rankEnabled ? 1 : 0 }}
                  className="topicon"
                ></CardMedia>
              </Box>
            ) : (
              <Box
                sx={{
                  height: '36px',
                  width: '36px',
                  background: '#356F92',
                  borderRadius: '50%',
                  opacity: selectedCard?.rankEnabled ? 1 : 0,
                }}
                className="d-flex, justify-content-center text-center"
              >
                <Typography
                  sx={{
                    color: '#ffffff',
                    fontFamily: 'HK Grotesk bold',
                    fontSize: '20px',
                  }}
                  variant="span"
                >
                  {index}
                </Typography>
              </Box>
            )}
            {mp.user_avatar ? (
              <Box className="text-center position-relative bottom-16 ">
                <Avatar
                  alt="cross"
                  src={mp.user_avatar}
                  className="img-circle leader-circle-img mr-1 profile-img-box-shadow mpcard-avatar"
                  draggable="false"
                />
              </Box>
            ) : (
              <Box className="text-center position-relative bottom-16 ">
                <AccountCircleIcon
                  className="profile-icon-box-shadow"
                  sx={{
                    fontSize: 'xx-large',
                    width: '70px',
                    height: 'auto',
                    color: '#EEEEEE',
                  }}
                />
              </Box>
            )}
            <Box className="leader-content ellipsewe-name">
              <Typography
                className="ellipsewe1"
                sx={{
                  color: '#356f92',
                  fontFamily: 'HK Grotesk bold',
                  fontSize: '20px',
                }}
              >
                {mp?.user_name}
              </Typography>
              <Typography className="ellipsewe1 mp-card-designation">{mp?.designation}</Typography>
              {mp?.house === 'Rajya Sabha' ? (
                <Typography
                  className="ellipsewe1"
                  sx={{ color: '#707a89', fontSize: '12px', fontFamily: 'HK Grotesk medium' }}
                >
                  State: {mp?.state_name}
                </Typography>
              ) : (
                <Typography
                  className="ellipsewe1"
                  sx={{ color: '#707a89', fontSize: '12px', fontFamily: 'HK Grotesk medium' }}
                >
                  Constituency: {mp?.constituency_name}
                </Typography>
              )}
            </Box>
            {columns && columns.length == 1 && (
              <Box className="score-container">
                <Typography variant="h3" className="card-content">
                  {columns[0]}
                </Typography>
                <Typography variant="span">{mp[columns[0]]}</Typography>
              </Box>
            )}
            {columns && columns?.length > 1 && (
              <Box className="score-container font-14">
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                  {columns?.map((item, index) => {
                    return (
                      <>
                        <Grid item xs={9} className="mt-1">
                          {item}
                        </Grid>
                        <Grid item xs={3} className="mt-1">
                          {mp?.[item]}
                        </Grid>
                      </>
                    )
                  })}
                </Grid>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Grid>
  )
}
export default EngagementCard
